import React, { Component } from "react";
import PropTypes from "prop-types";
import { observer, inject } from "mobx-react";

import { Modal } from "arv-reactcomponents";
import SizeBlock from "../ProductList/SizeBlock";
import { PDP_SIZE_MODAL_TITLE } from "npmlinks-constants";

@inject("ProductStore")
@observer
class SizePrompt extends Component {
  componentWillReceiveProps(nextProps) {
    const { sizeChartId, ProductStore } = this.props;

    if (nextProps.showSizePrompt && sizeChartId) {
      this.props.ProductStore.getFitGuideDtails(sizeChartId);
    }
  }

  render () {
    const {
      className,
      showSizePrompt,
      closePrompt,
      skus,
      selectSku,
      fitGuideModal,
      sizeChartId,
      ProductLoader,
      selectedSkuId,
      sizeRecommendation,
    } = this.props;
    return (
      <Modal
        isOpen={showSizePrompt}
        onClose={closePrompt}
        className="nw-pdp-sizeprompt"
      >
        <div className="nw-pdp-sizeprompt">
          <div className="nw-pdp-sizepromptlist">
            <div className="nw-pdp-sizeprompttext">{PDP_SIZE_MODAL_TITLE}</div>
            <SizeBlock.component
              selectedSkuId={selectedSkuId}
              selectSku={selectSku}
              skus={skus}
              ProductLoader={ProductLoader}
              fitGuideModal={fitGuideModal}
              sizeChartId={sizeChartId}
              sizeRecommendation = {sizeRecommendation}
            />
          </div>
        </div>
      </Modal>
    );
  }
}

SizePrompt.wrappedComponent.defaultProps = {
  ProductLoader: false,
  fitGuideModal: "",
  sizeChartId: "",
  selectedSkuId: "",
  sizeRecommendation: "",
};

SizePrompt.wrappedComponent.propTypes = {
  className: PropTypes.string.isRequired,
  showSizePrompt: PropTypes.bool.isRequired,
  skus: PropTypes.shape({}).isRequired,
  selectSku: PropTypes.func.isRequired,
  closePrompt: PropTypes.func.isRequired,
  selectedSkuId: PropTypes.string,
  ProductLoader: PropTypes.bool,
  fitGuideModal: PropTypes.func,
  sizeChartId: PropTypes.string,
  sizeRecommendation: PropTypes.string,
  ProductStore: PropTypes.shape({
    getFitGuideDtails: PropTypes.func.isRequired,
    sizeChartData: PropTypes.shape({}),
    pdpDetails: PropTypes.shape({}),
  }).isRequired,
};

const getFinalComponent = component => inject("ProductStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: SizePrompt,
  component: SizePrompt,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/SizePrompt/index.js